import { useContext } from 'react';
import { storeContext } from '~web/store';
import { BaseStore } from '~web/store/base/base-store';

/**
 * Use this hook to retrieve a store from React's Context.
 * This replaces the old inject way.
 * @param store
 */
export const useStore = <T extends BaseStore>(store: BaseStore): T => {
  const context = storeContext.get(store);
  if (!context) {
    throw Error(`Context not found for ${store.constructor.name}.`);
  }
  return useContext(context);
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/hooks/use-store.ts